interface CardSkeletonProps {
	skeletonCount?: number;
}

export const CardSkeleton = ({ skeletonCount = 1 }: CardSkeletonProps) => {
	return (
		<>
			{Array.from({ length: skeletonCount }).map((_, index) => (
				<div
					// biome-ignore lint/suspicious/noArrayIndexKey: This is a static skeleton list where order doesn't change
					key={`card-skeleton-${index}`}
					className="relative bg-white rounded-xl overflow-hidden animate-pulse h-[350px] border border-gray-200"
				>
					{/* Image placeholder */}
					<div className="p-3">
						<div className="bg-gray-200 h-[250px] border border-gray-200 rounded-xl" />
					</div>

					{/* Content overlay at bottom */}
					<div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-white to-transparent">
						{/* Text content skeleton */}
						<div className="space-y-2">
							<div className="h-4 bg-gray-200 rounded w-5/6" />
							<div className="h-4 bg-gray-200 rounded w-2/3" />
						</div>
					</div>
				</div>
			))}
		</>
	);
};
